// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-info[data-v-2a9a94c7] {
  position: relative;
}
.contact-info.loading[data-v-2a9a94c7] {
  overflow-y: hidden !important;
}
.contact-info .region-photo-wrapper[data-v-2a9a94c7] {
  height: 283.5px;
  min-height: 283.5px;
  overflow: hidden;
}
.contact-info .region-photo-wrapper img[data-v-2a9a94c7] {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.contact-info .loading-spinner-wrapper[data-v-2a9a94c7] {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 100;
  margin-bottom: 0 !important;
}
.contact-info .loading-spinner-wrapper .loading-spinner[data-v-2a9a94c7] {
  margin: auto;
}
.contact-info .loading-spinner-wrapper .loading-spinner i[data-v-2a9a94c7] {
  font-size: 18px;
  font-weight: lighter;
}
.acs-journal-wrapper[data-v-2a9a94c7] {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: min-content;
  background-color: initial !important;
  box-shadow: initial !important;
}
.acs-journal-wrapper .acs-journal[data-v-2a9a94c7] {
  display: flex;
  flex-direction: column;
  background-color: var(--content-container-bgcolor);
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);
}
.acs-journal-wrapper .acs-journal .journal-title[data-v-2a9a94c7] {
  color: #2977c2;
  padding: 10px 15px;
  font-size: 0.9em;
  color: var(--message-grey-color);
}
.acs-journal-wrapper .acs-journal .header[data-v-2a9a94c7] {
  color: var(--message-grey-color);
  display: flex;
  flex-direction: row;
}
.acs-journal-wrapper .acs-journal .header .title[data-v-2a9a94c7] {
  color: var(--message-grey-color);
  flex-grow: 1;
  text-align: left;
  font-weight: 600;
  padding: 0 10px;
}
.acs-journal-wrapper .acs-journal .header .edit-btn[data-v-2a9a94c7] {
  margin: auto 34px;
  color: var(--base-blue-color);
  cursor: pointer;
}
.acs-journal-wrapper .acs-journal .tmp[data-v-2a9a94c7] {
  margin: 10px;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/AcsJournal.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,yCAAyC;AAC3C;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".contact-info[data-v-2a9a94c7] {\n  position: relative;\n}\n.contact-info.loading[data-v-2a9a94c7] {\n  overflow-y: hidden !important;\n}\n.contact-info .region-photo-wrapper[data-v-2a9a94c7] {\n  height: 283.5px;\n  min-height: 283.5px;\n  overflow: hidden;\n}\n.contact-info .region-photo-wrapper img[data-v-2a9a94c7] {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n.contact-info .loading-spinner-wrapper[data-v-2a9a94c7] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  z-index: 100;\n  margin-bottom: 0 !important;\n}\n.contact-info .loading-spinner-wrapper .loading-spinner[data-v-2a9a94c7] {\n  margin: auto;\n}\n.contact-info .loading-spinner-wrapper .loading-spinner i[data-v-2a9a94c7] {\n  font-size: 18px;\n  font-weight: lighter;\n}\n.acs-journal-wrapper[data-v-2a9a94c7] {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1;\n  min-height: min-content;\n  background-color: initial !important;\n  box-shadow: initial !important;\n}\n.acs-journal-wrapper .acs-journal[data-v-2a9a94c7] {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--content-container-bgcolor);\n  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.08);\n}\n.acs-journal-wrapper .acs-journal .journal-title[data-v-2a9a94c7] {\n  color: #2977c2;\n  padding: 10px 15px;\n  font-size: 0.9em;\n  color: var(--message-grey-color);\n}\n.acs-journal-wrapper .acs-journal .header[data-v-2a9a94c7] {\n  color: var(--message-grey-color);\n  display: flex;\n  flex-direction: row;\n}\n.acs-journal-wrapper .acs-journal .header .title[data-v-2a9a94c7] {\n  color: var(--message-grey-color);\n  flex-grow: 1;\n  text-align: left;\n  font-weight: 600;\n  padding: 0 10px;\n}\n.acs-journal-wrapper .acs-journal .header .edit-btn[data-v-2a9a94c7] {\n  margin: auto 34px;\n  color: var(--base-blue-color);\n  cursor: pointer;\n}\n.acs-journal-wrapper .acs-journal .tmp[data-v-2a9a94c7] {\n  margin: 10px;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
